<template>
  <div id="productionTotal">
    <van-nav-bar
        title="数据展示"
        right-text="刷新"
        left-arrow
        left-text="返回"
        @click-left="onClickLeft"
        @click-right="onClickRight"
    />
    <van-row type="flex" justify="center">
      <van-col span="20">
        <div style="height: 300px" ref="productionCar"></div>
      </van-col>
    </van-row>
  </div>
</template>
<script>

import * as echarts from 'echarts'
import {Toast} from "vant";
export default {
  data () {
    return {
      productionCarOption: {
        title: {
          text: new Date().getFullYear() + '年' + new Date().getMonth() + '月生产情况',
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c}车',
          textStyle: {
            fontWeight: 'bold'
          }
        },
        dataZoom: [
          // {
          //   type: 'slider', // 类型为滑动条
          //   start: 0,      // 数据窗口的起始位置（0% - 100%）
          //   end: 100       // 数据窗口的结束位置（0% - 100%）
          // },
          {
            type: 'inside', // 类型为内置型
            start: 90,       // 数据窗口的起始位置（0% - 100%）
            end: 100,       // 数据窗口的结束位置（0% - 100%）
            xAxisIndex: [0] // 控制 x 轴
          }
        ],
        xAxis: {
          type: 'category',
          data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30']
        },
        yAxis: {
          type: 'value',
          name: '车数'
        },
        series: [
          {
            data: [1253, 1135, 1356, 1020, 1253, 1135, 1356, 1020, 1253, 1135, 1356, 1020, 1253, 1135, 1356, 1020, 1253, 1135, 1356, 1020, 1253, 1135, 1356, 1020, 1253, 1135, 1356, 1020, 1356, 1020],
            type: 'line'
          },
          {
            data: [1253, 1135, 1356, 1020, 1253, 1135, 1356, 1020, 1253, 1135, 1356, 1020, 1253, 1135, 1356, 1020, 1253, 1135, 1356, 1020, 1253, 1135, 1356, 1020, 1253, 1135, 1356, 1020, 1356, 1020],
            type: 'bar'
          }
        ]
      },
    }
  },
  methods: {
    loading () {
      const productionCarChart = echarts.init(this.$refs.productionCar)
      productionCarChart.setOption(this.productionCarOption)
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    onClickRight() {
      this.loading()
      Toast('已刷新');
    },
  },
  mounted() {
    this.loading()
  }
}
</script>
